<style lang="scss" scoped>
  .footercontent {
    background: #71B4FF;
    width: 100%;
    min-width:1200px;
    color: #fff;
    .pcFooter {
      width: 1200px;
      display: block;
      margin: 0 auto;
      border-bottom: 1px solid #fff;
    }
    .footInfo {
      display: flex;
      justify-content: space-around;
      padding-top: 100px;
      .codeInfo {
        position: relative;
        top: -50px;
        height: 135px;
        .code {
          display: block;
          height: 120px;
          width: 120px;
          margin-bottom: 5px;
        }
        .codeText {
          text-align: left;
        }
      }
      .listBox {
        text-align: left;
        .title {
          font-size: 19px;
          font-weight: 600;
          margin-bottom: 8px;
        }
        .listInfo {
          font-size: 14px;
          font-weight: 400;
          p {
            padding-bottom: 14px;
            cursor: pointer;
          }
        }
      }
    }
    .footerText {
      font-size: 14px;
      line-height: 28px;
      text-align: center;
      padding: 30px 0 50px;
      .footIcon {
        height: 15px;
        width: 15px;
        margin-right: 5px;
      }
      a {
        display: inline-block;
        color: #fff;
        font-size: 12px;
        margin-right: 24px;
      }
    }
  }
</style>
<template>
  <div class="footercontent">
    <div class="pcFooter">
      <div class="footInfo flex">
        <div class="listBox">
          <p class="title">盈信保险经纪</p>
          <div class="listInfo">
            <p @click="golink('/linkus')">联系我们</p>
          </div>
        </div>

        <div class="listBox">
          <p class="title">全国统一服务热线/投诉热线</p>
          <div class="listInfo">
            <p>0756-2999160</p>
          </div>
        </div>
        <div class="listBox">
          <p class="title">全国统一回访电话</p>
          <div class="listInfo">
            <p>0756-2999160</p>
          </div>
        </div>
        <div class="listBox codeInfo">
          <img class='code' src="../assets/images/erweima.jpg" />
          <div class="listInfo codeText">
            <p>关注微信公众号 <br>获取更多信息</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footerText">
      <p>版权所有 © 2021 广东盈信保险经纪有限公司</p>
      <p>
        <a href="https://www.iachina.cn/" target="_blank">保险业务经营许可证：260917000000800</a>
        <a v-if="isCn == 1" href="javascript:;" @click="gogognanOne">粤ICP备2022083545号-1</a>
        <a v-if="isCn == 2" href="javascript:;" @click="gogognanOne">粤ICP备2022083545号-2</a>
        <a v-if="isCn == 3" href="javascript:;" @click="gogognanOne">粤ICP备2022083545号-3</a>
        <img class="footIcon" src="../assets/images/footIcon.png">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049202000321">粤公网安备 44049202000321号</a>
      </p>
    </div>
  </div>
</template>
<script>
  import Store from '../vuex/index';
  export default {
    name: "footercontent",
    computed: {
      isFixed: function() {
        return Store.state.isFixed
      }
    },
    data() {
      return {
        isCn: ''
      }
    },
    mounted() {
      this.isCnFun()
    },
    
    methods: {
      golink(router, index) {
        this.$nextTick(() => {
          this.$router.push({
            path: router,
            query: {
              'index': index
            }
          })
        })
      },
      isCnFun() {
        if(window.location.hostname == 'www.yingxin-inc.cn'){
          this.isCn = 2
        }else if(window.location.hostname == 'www.yinxingbao.com'){
          this.isCn = 3
        } else{
        	this.isCn = 1
        }
      },
      goTop() {
        $('html , body').animate({
          scrollTop: 0
        }, 'slow');
      },
      gogognanOne() {
        window.open('https://beian.miit.gov.cn/')
      },
      gogognanTwo() {
        window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502003108')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/footercontent.vue